import Image from 'next/image';
import Link from 'next/link';
import styled from 'styled-components';

const contentfulLoader = ({ src, width, quality }) => {
  return `${src}?w=${width}&q=${quality || 75}`;
};

const PreviewImageWrapper = styled.div`
  margin: auto;
  img {
    transition: background 250ms, transform 250ms;
    &:hover {
      transform: scale(1.05);
      background-position: 100% 100%;
      opacity: 0.8;
    }
  }
`;

const PreviewImage = (props) => {
  const image = props.src ? (
    <Image loader={contentfulLoader} {...props} />
  ) : (
    <></>
  );
  return (
    <Link href={props.link} aria-label={props.title}>
      {image}
    </Link>
  );
};

export default PreviewImage;
